"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.getServerSideProps = exports.fetchRemoteComponent = exports.RemoteComponent = exports.createRemoteComponent = exports.getDependencies = exports.createRequires = exports.createUseRemoteComponent = void 0;
var useRemoteComponent_1 = require("./hooks/useRemoteComponent");
__createBinding(exports, useRemoteComponent_1, "createUseRemoteComponent");
var createRequires_1 = require("./createRequires");
__createBinding(exports, createRequires_1, "createRequires");
var getDependencies_1 = require("./getDependencies");
__createBinding(exports, getDependencies_1, "getDependencies");
var createRemoteComponent_1 = require("./createRemoteComponent");
__createBinding(exports, createRemoteComponent_1, "createRemoteComponent");
var RemoteComponent_1 = require("./components/RemoteComponent");
__createBinding(exports, RemoteComponent_1, "RemoteComponent");
var fetchRemoteComponent_1 = require("./fetchRemoteComponent");
__createBinding(exports, fetchRemoteComponent_1, "fetchRemoteComponent");
var getServerSideProps_1 = require("./getServerSideProps");
__createBinding(exports, getServerSideProps_1, "getServerSideProps");
//# sourceMappingURL=index.js.map